module.exports = __webpack_public_path__ + "img/collection-weddingRingsCeramic@2x.1750264.jpg";